import { render, staticRenderFns } from "./EventSponsorSummary.vue?vue&type=template&id=4bcada81"
import script from "./EventSponsorSummary.vue?vue&type=script&lang=js"
export * from "./EventSponsorSummary.vue?vue&type=script&lang=js"
import style0 from "./EventSponsorSummary.vue?vue&type=style&index=0&id=4bcada81&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports